import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { tracerSlice } from './_tracer.slice';

export const Tracer = ({ optionId, isTraced, children }) => {
  const dispatch = useDispatch();

  const loginId = useSelector((state) => state.auth.loginId);

  useEffect(() => {
    if (!isTraced) {
      dispatch(tracerSlice.actions.tracerRequest({ loginId, optionId }));
    }
  }, []);

  return children;
};
